/**
 * @generated SignedSource<<69bdcc782317d4e6e8ba97127e901b98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AccountStatus = "active" | "closed" | "inactive" | "%future added value";
export type AtlassianAccountUserQuery$variables = {};
export type AtlassianAccountUserQuery$data = {
  readonly me: {
    readonly user: {
      readonly accountId: string;
      readonly accountStatus: AccountStatus;
      readonly email?: string | null;
      readonly name: string;
      readonly nickname?: string | null;
      readonly picture?: any;
      readonly " $fragmentSpreads": FragmentRefs<"AtlassianAccountUserFragment">;
    } | null;
  };
};
export type AtlassianAccountUserQuery = {
  response: AtlassianAccountUserQuery$data;
  variables: AtlassianAccountUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountStatus",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nickname",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AtlassianAccountUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AtlassianAccountUserFragment"
                  }
                ],
                "type": "AtlassianAccountUser",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AtlassianAccountUserQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "type": "AtlassianAccountUser",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7d5ee8d4a42df8125ee378a819cf0be7",
    "id": null,
    "metadata": {},
    "name": "AtlassianAccountUserQuery",
    "operationKind": "query",
    "text": "query AtlassianAccountUserQuery {\n  me {\n    user {\n      __typename\n      accountId\n      accountStatus\n      name\n      ... on AtlassianAccountUser {\n        email\n        nickname\n        picture\n        ...AtlassianAccountUserFragment\n      }\n      id\n    }\n  }\n}\n\nfragment AtlassianAccountUserFragment on AtlassianAccountUser {\n  id\n  email\n  nickname\n  name\n  accountId\n  accountStatus\n  picture\n}\n"
  }
};
})();

(node as any).hash = "a743a411d81393e057da5117241d38ac";

export default node;
